import { DRAWER_ENTITIES } from '@/lib/constants/drawers'

export const DRAWER_STACK = {
  LIMIT_REACHED: 'Drawer limit reached. Close one to open more',
  ENTITIES: {
    [DRAWER_ENTITIES.CONTROL]: 'Control',
    [DRAWER_ENTITIES.DOCUMENT]: 'Document',
    [DRAWER_ENTITIES.EVIDENCE]: 'Evidence',
    [DRAWER_ENTITIES.TASK]: 'Task',
    [DRAWER_ENTITIES.EMPLOYEE]: 'Employee',
  },
}
